import styled, { css } from 'styled-components'

import I from 'ui/elements/I'
import InputElement from 'ui/elements/Input'

import { injectModifiers, size, color, fontSize, unit, truncate } from 'ui/themes/utils'
import modifiers from 'ui/themes/modifiers'

export const Input = styled(InputElement)`
  ${(props) => props.lineThrough && css`
    text-decoration: line-through;
  `}

  ${(props) => props.uppercase && css`
    text-transform: uppercase;

    &::placeholder {
      text-transform: none;
    }
  `}

  ${(props) => props.type === 'number' && props.hideArrows && css`
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  `}

  ${(props) => props.truncate && css`
    ${truncate()}
  `}
`

const BaseAddon = styled.span`
  line-height: ${size('controlHeight')};
  border-radius: ${size('borderRadius', 'sm')};

  > * {
    display: block;

    width: 100%;
    height: 100%;

    padding: 0;
    text-align: center;
  }

  ${({ theme }) => injectModifiers(modifiers(theme))}
`

export const Prefix = styled(BaseAddon)``

export const Suffix = styled(BaseAddon)`
  ${(props) => props.border && css`
    border-left: ${size('borderWidth')} solid ${color('Misc/Divider')};
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  `}
`

export const InputContainer = styled.span`
  &&& {
    display: block;

    position: relative;

    font-size: ${fontSize()};

    ${({ hasSuffix }) => hasSuffix && css`
      width: 100%;
      display: inline-flex;
      align-items: center;

      background: ${color('white')};

      border: ${size('borderWidth')} solid ${color('Misc/Divider')};
      border-radius: ${size('borderRadius', 'sm')};

      &:has(input:disabled) {
        background: ${color('Secondary/Background1')};
      }

      &:has(input[data-error]) {
        border-color: ${color('Danger/Base')};
      }

      > ${Prefix}, ${Suffix} {
        flex-shrink: 0;
      }

      > ${Input} {
        border: none;
        padding: 0;
        padding-left: ${unit(3)};
      }

      ${Prefix} + ${Input} {
        padding-left: 0;
      }
    `}

    ${({ hasSuffix }) => !hasSuffix && css`
      > ${Prefix}, ${I} {
        position: absolute;

        height: ${size('controlHeight')};
        width: ${size('controlHeight')};

        color: ${color('Text/Tertiary')};

        text-align: center;

        pointer-events: none;
        line-height: ${size('controlHeight')};

        & + ${Input} {
          padding-left: ${size('controlHeight')};
        }

        &.fa-spinner-third {
          color: ${color('Primary/Base')};
        }
      }
    `}
  }
`
